import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Tracks which course the shell is currently scoped to (drives the LeftNav tree
// and the TopBar title). Set from the URL (/courses/:id, /lessons/:id resolves
// to a course) or from the Dashboard course picker. Persisted so a deep-link
// reload into /lessons/:id can still render the right nav before data loads.
interface CourseState {
  currentCourseId: string | null;
  setCurrentCourseId: (id: string | null) => void;
}

export const useCourseStore = create<CourseState>()(
  persist(
    (set) => ({
      currentCourseId: null,
      setCurrentCourseId: (id) => set({ currentCourseId: id }),
    }),
    { name: 'acechem-course' }
  )
);
